import React from "react";
import PickUp from "../../Assets/Images/pickup.png";
import Washing from "../../Assets/Images/washing.png";
import Delivery from "../../Assets/Images/delivery.png";
import Moment from "react-moment";

const ProfileCard = ({ setTailoringOrders, setSelectedOrder, selectedOrder, item, index }) => {
  return (
    <div
      key={index}
      onClick={() => {
        setTailoringOrders(true);
        setSelectedOrder(item);
      }}
      className="col-12 historydetails hd"
    >
      <div className="col-xsm-4">
        <div>
          <p>{item.order_id}</p>
          <p>
            <span>
              <Moment format="HH:mm">{item.created_at}</Moment> |{" "}
            </span>
            <span>
              <Moment format="YYYY/MM">{item.created_at}</Moment>
            </span>
          </p>
        </div>
      </div>
      <div className="col-xsm-6">
        <div>
          <p className="text-capitalize">{item.tailoring_name}</p>
          <p>{item.quantity} items </p>
          <p>
            {/* <span>Pickup: {item.pick_up}</span> */}
            <span>
              Delivery:{" "}
              {item.delivery === "onsite" ? "On site" : item.delivery_address}
            </span>
          </p>
        </div>
      </div>
      <div className="col-xsprice ">
        <p>₦{item.tailoring_price}</p>
      </div>
      <div className="col-xsm-12">
        {/* <span className={item.status === 0 ? 'opacity-25' : 'opacity-100'}>
          <img alt="" src={PickUp} />
          <span className="hr-sepe"></span>
        </span>
        <span className={item.status === 0 ? 'opacity-25' : item.status === 1 ? 'opacity-100' : ''}>
          <img alt="" src={Washing} />
          <span className="hr-sepe"></span>
        </span>
        <span className={item.status === 0 ? 'opacity-25' : item.status === 1 ? 'opacity-25' : item.status === 2 ? 'opacity-100' : ''}>
          <img alt="" src={Delivery} />
        </span> */}
        <div style={{color: "#BC9A43", maxWidth: "300px", width: "100%"}}>{item.status === 1 ? "Pending" : item.status === 2 ? "In Progress" : "Completed"}</div>
      </div>
    </div>
  );
};

export default ProfileCard;
